<gh-dropdown *ngIf="menuItems" [menuItems]="menuItems" [hasCustomButtonContent]="true" (dropdownToggled)="dropdownToggled($event)" placement="bottomRight">
  <button
    id="createNewOKRBtn"
    [disabled]="disabled"
    [attr.aria-expanded]="dropdownVisible"
    uiType="primary"
    uiShape="round"
    gh-dropdown-custom-button-content
    ui-button
    aria-haspopup="true"
    uiTrigger="click">
    <span class="selected">
      <span class="text">{{ "create_okr" | localize }} </span>
    </span>
    <i class="sp-ml-10 fs-10px" ui-icon uiType="down"></i>
  </button>
</gh-dropdown>
